module.exports = __webpack_public_path__ + "img/timeSelected.746fdd85.jpg";